<template>
  <v-container fluid>
    <SidebarNavigation />
    <v-card>
      <v-tabs v-model="tab">
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab v-for="item in tabItems" :key="item">
          {{ item }}
        </v-tab>
      </v-tabs>
    </v-card>
    <v-card>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-row class="pt-3 pr-2 d-flex justify-end">
            <v-col cols="auto">
              <v-text-field
                v-model="pagination.search"
                label="Search"
                append-icon="mdi-magnify"
                dense
                hide-details
                class="search-input"
                style="max-width: 250px"
                outlined
                @input="debouncedSearch"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-data-table
                mobile-breakpoint="0"
                fixed-header
                dense
                class="elevation-5"
                :headers="tableHeaders"
                :items="parameterList"
                :items-per-page.sync="pagination.itemsPerPage"
                :page.sync="pagination.page"
                :sort-by="pagination.sortBy"
                :sort-desc="pagination.sortDesc"
                :server-items-length="totalParameter"
                item-key="id"
                @update:page="updateQuery('page', $event)"
                @update:items-per-page="updateQuery('itemsPerPage', $event)"
                @update:sort-by="updateQuery('sortBy', $event)"
                @update:sort-desc="updateQuery('sortDesc', $event)"
              >
                <template v-slot:body="{ items }">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>{{ item.name }}</td>
                      <td>{{ item.value }}</td>
                      <td>{{ item.noted }}</td>
                      <!-- <td>
                        <div class="small-font">
                          {{ item.created_by_name }}
                        </div>
                        <div class="small-font">
                          {{ item.created_on }}
                        </div>
                      </td> -->
                      <td>
                        <v-btn icon @click="openDialogUpdate(item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- update -->
    <v-dialog v-model="isDialogOpenEdit" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Ubah Parameter</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValidUpdate">
            <!-- <v-text-field
              :rules="[(v) => !!v || 'Nama tidak boleh kosong !']"
              v-model="name"
              label="Nama"
            ></v-text-field> -->
            <v-text-field
              :rules="[(v) => !!v || 'Value tidak boleh kosong !']"
              v-model="value"
              label="Value"
            ></v-text-field>
            <v-text-field
              :rules="[(v) => !!v || 'Catatan tidak boleh kosong !']"
              v-model="noted"
              label="Catatan"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpenEdit = false"
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            :disabled="!isFormValidUpdate"
            @click="submitUpdate"
            >Update</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      tabItems: ["Parameter"],
      isLoading: false,
      search: "",
      tab: 1,
      tableHeaders: [
        { text: "Name", align: "center", value: "name" },
        { text: "Value", align: "center", value: "value" },
        { text: "Catatan", align: "center", value: "noted" },
        // { text: "Dibuat Oleh", align: "center" },
        { text: "Aksi", align: "center" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: true,
        search: "",
      },
      totalParameter: null,
      parameterList: [],
      parameter: { name: "" },
      isDialogOpenEdit: false,
      isFormValidUpdate: false,
      name: null,
      value: null,
      noted: null,
      type: null,
    };
  },
  methods: {
    fetchParameters() {
      store.dispatch("showLoading");
      const query = this.$route.query;
      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "name",
        sortDesc: query.sortDesc || this.pagination.sortDesc || false,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      api
        .get("/parameters", { params })
        .then(({ data }) => {
          this.parameterList = data.data.data;
          this.totalParameter = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching parameters:", error);
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    openDialogUpdate(params = null) {
      console.log(params);
      this.parameter = params;
      this.name = params.name;
      this.value = params.value;
      this.noted = params.noted;
      this.type = params.type;
      this.isDialogOpenEdit = true;
    },
    openDialogDelete(params) {
      this.employee = params;
      this.isDialogOpenDelete = true;
    },
    submitUpdate() {
      store.dispatch("showLoading");
      const payload = {
        id: this.parameter.id,
        name: this.name,
        value: this.value,
        noted: this.noted,
        type: this.type,
      };
      api
        .post("/parameters/update", payload)
        .then((response) => {
          const message = response.data.message;
          this.fetchParameters();
          this.isDialogOpenEdit = false;
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save paramater!";
          if (error.response) {
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message;
          }
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    updatePagination(query) {
      // console.log(query);
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.selectedDivisionId = parseInt(query.divisionId) || 0;
      this.selectedPositionId = parseInt(query.positionId) || 0;
      this.selectedSiteId = parseInt(query.siteId) || 0;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  mounted() {
    store.commit("setTitle", "Parameter");
    this.updatePagination(this.$route.query);
  },
  watch: {
    pagination: {
      handler: "fetchParameters",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(2),
td:nth-child(4),
td:nth-child(5) {
  text-align: center;
}
</style>
